module.exports = __webpack_public_path__ + "images/stickers/smile@2x.fa6754c4dd9625bdce76.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/smile@2x.png
// module id = UpVq
// module chunks = 13